import React from "react";
import { Card, CardHeader } from "../core/Card.jsx";
import { Loader } from "./Loader.jsx";

/* Loading placeholder card — replaces legacy uiComponents SkeletonCard. */
export function SkeletonCard({ heading, style, ...rest }) {
  return (
    <Card style={style} {...rest}>
      <CardHeader title={heading} />
      <div style={{ marginTop: 15, width: "100%" }}>
        <Loader variant="section" label={`Loading ${heading}`} />
      </div>
    </Card>
  );
}

export default SkeletonCard;
